import _asyncToGenerator from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store';
import { deviceInfo } from '../utils/env';
Vue.use(VueRouter);
var deviceInfoData = deviceInfo();
var routes = [{
  path: '/recharge/index',
  name: 'recharge-index',
  component: function component() {
    return import( /* webpackChunkName: "recharge-index" */'../index.vue');
  }
}, {
  path: '/recharge/history',
  name: 'recharge-history',
  component: function component() {
    return import( /* webpackChunkName: "recharge-history" */'../history.vue');
  }
}, {
  path: '/recharge/payResult',
  name: 'recharge-payResult',
  component: function component() {
    return import( /* webpackChunkName: "recharge-payResult" */'../../main/views/diamond/payResult.vue');
  }
}, {
  path: '/recharge/login',
  name: 'recharge-login',
  component: function component() {
    return import( /* webpackChunkName: "recharge-login" */'../login.vue');
  }
}, {
  path: '/recharge/app-login',
  name: 'recharge-app-login',
  component: function component() {
    return import( /* webpackChunkName: "recharge-app-login" */'../app-login.vue');
  }
}, {
  path: '*',
  redirect: '/recharge/index'
}];
var router = new VueRouter({
  mode: 'history',
  base: '/',
  routes: routes
});
router.beforeEach( /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(to, from, next) {
    var fullPath, login, logined;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return store.dispatch('login/queryUserInfo');
          case 2:
            fullPath = to.fullPath.split('?')[0];
            login = store.state.login;
            logined = login.logined;
            if (!logined) {
              if (deviceInfoData.isInApp) {
                if (fullPath !== '/recharge/app-login') {
                  next({
                    path: '/recharge/app-login'
                  });
                } else {
                  next();
                }
              } else if (fullPath !== '/recharge/login') {
                next({
                  path: '/recharge/login'
                });
              } else {
                next();
              }
            } else {
              next();
            }
          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());
export default router;